import type { IBillingProfileDataWeb } from '@/app-package';
import axios from 'axios';

/** Return a billing profile associated with a user or brokerage in BillingPlatform. */
export const getBillingProfile = async ({
  billingCustomerNumber,
}: {
  billingCustomerNumber: string;
}): Promise<IBillingProfileDataWeb> => {
  try {
    const { data } = await axios.get<IBillingProfileDataWeb>(
      `/billing/billing_profile/${billingCustomerNumber}`,
    );
    return data;
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      return undefined;
    }
    throw error;
  }
};
